import React, { useState, useMemo } from "react";
import { Table, Typography } from "antd";
import { getCreditLimitColumns } from "./getCreditLimitColumns";
import CustomModal from "../../../components/CustomModal/CustomModal";
import { TABLE_PAGINATION } from "../../../constants/tableConfig";

const { Paragraph, Text } = Typography;

const CreditLimitTable = ({
  data = [],
  loading = false,
  searchText = "",
  onEdit,
  onRequestAgain,
}) => {
  const [selectedRecordForReason, setSelectedRecordForReason] = useState(null);

  const filteredData = useMemo(() => {
    if (!searchText) return data;
    const query = searchText.toLowerCase();
    return data.filter(
      (item) =>
        item.enterpriseName?.toLowerCase().includes(query) ||
        item.requestId?.toLowerCase().includes(query) ||
        item.status?.toLowerCase().includes(query)
    );
  }, [data, searchText]);

  const columns = useMemo(
    () =>
      getCreditLimitColumns({
        onEdit,
        onRequestAgain,
        onViewReason: (record) => setSelectedRecordForReason(record),
      }),
    [onEdit, onRequestAgain]
  );

  return (
    <>
      <Table
        columns={columns}
        dataSource={filteredData}
        loading={loading}
        rowKey="requestId"
        pagination={TABLE_PAGINATION}
        className="credit-limit-table"
        scroll={{ x: 1000 }}
      />

      {selectedRecordForReason && (
        <CustomModal
          title="Rejection Reason"
          open={Boolean(selectedRecordForReason)}
          onCancel={() => setSelectedRecordForReason(null)}
          centered
          content={
            <div style={{ padding: "12px 0" }}>
              <Paragraph>
                <Text strong>Enterprise: </Text>
                {selectedRecordForReason.enterpriseName}
              </Paragraph>
              <div
                style={{
                  background: "#fff1f0",
                  border: "1px solid #ffa39e",
                  borderRadius: 6,
                  padding: "12px 16px",
                  marginTop: 12,
                }}
              >
                <Text type="danger" strong style={{ display: "block", marginBottom: 4 }}>
                  Admin Feedback:
                </Text>
                <Text>{selectedRecordForReason.rejectionReason || "No details provided."}</Text>
              </div>
            </div>
          }
        />
      )}
    </>
  );
};

export default CreditLimitTable;
